/**
 * Конфиг хлебных крошек и заголовков страниц (02_GPT-MODULAR).
 * Для новых вкладок — добавить путь, массив крошек и заголовок.
 */

export const BREADCRUMB_ROUTES = {
    "/": ["Home"],
    "/services": ["Home", "Services"],
    "/pages": ["Home", "Services", "FAQ's"],
    "/contact": ["Home", "Services", "FAQ's", "Contact"],
    "/program": ["Home", "Services", "Media Service Projector"],
    "/code-redactor": ["Home", "Services", "Making Sense"],
    "/admin-panel": ["Home", "Services", "Admin Panel"],
    "/projects": ["Home", "Projects"],
    "/dev": ["Home", "Developer"],
    // Пример: "/blog": ["Home", "Blog"],
};

export const PAGE_TITLES = {
    "/": "Homepage",
    "/services": "Services",
    "/pages": "FAQ's",
    "/contact": "Contact",
    "/program": "Media Service Projector",
    "/code-redactor": "Making Sense",
    "/admin-panel": "Admin Panel",
    "/projects": "Projects",
    "/dev": "Developer",
};

/** Зелёная подпись «Our Services» над миссионным текстом (по макету Group 7). */
export const PAGE_LABEL_GREEN = {
    "/services": "Our Services",
    "/program": "Media Service Projector",
    "/code-redactor": "Making Sense",
    "/admin-panel": "Admin Panel",
    "/projects": "Our Projects",
};

/** Текст под зелёной плашкой — теперь на Services. */
export const PAGE_TEXT_BELOW_PLANK = {
    "/services": "Our Mission Is To Make Your Business Better Through Technology",
    "/program": "Accessible software for comfortable output of different media content to the audience",
    "/code-redactor": "More details about your code cleanup, refactoring, and modernization workflow.",
    "/admin-panel": "Connect Shopify, WooCommerce, Amazon and other sales sites to one panel.",
    "/projects": "All projects you can open and review in one place.",
};

export function getPageLabelGreen(pathname) {
    return PAGE_LABEL_GREEN[pathname] ?? null;
}

export function getPageTextBelowPlank(pathname) {
    return PAGE_TEXT_BELOW_PLANK[pathname] ?? null;
}

export function getBreadcrumbPath(pathname) {
    return BREADCRUMB_ROUTES[pathname] || ["Home"];
}

export function getPageTitle(pathname) {
    return PAGE_TITLES[pathname] ?? "Homepage";
}

export function breadcrumbToText(segments) {
    return segments.join(" > ");
}

// config/breadcrumbRoutes.js
